import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import swal from 'sweetalert';
import { connect, useSelector } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import AccessCodeForm from '../components/AccessCodeForm';
import { addNewAccessCode, createUserName } from '../api/accesscodeapi';
import LoaderComponent from '../components/LoaderComponent';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { getAccessCodeDialogStatus, getAccessCodeLoading, getControllersList } from '../selector/selectors';
import AccessCodeModal from '../components/AccessCodeModal';
import { closeAccessCodeDialog, loadAccessCodeLoginUsernameClear } from '../state/accesscode/actions';
import { loadRoleList } from '../api/roleapi';
import { loadControllersList } from '../api/controllerpermissionsapi';

dayjs.extend(utc);

const CreateAccessCode = ({
    isLoading,
    addNewLoginUserName,
    startLoadingRoleList,
    accessCodeDialogBoxStatus,
    //controllersList
}) => {
    const todayDate                           = dayjs().startOf("day");
    const dispatch                            = useDispatch(); 
    const [fromDate, setFromDate]             = React.useState(null);
    const [toDate, setToDate]                 = React.useState(null);
    const [fromMaxDate, setFromMaxDate]       = React.useState(null);
    const [toMinDate, setToMinDate]           = React.useState(null);
    const [toMaxDate, setToMaxDate]           = React.useState(null);
    const [selectedUser, setSelectedUser]     = React.useState(null);
    //const [userLevel, setUserLevel]           = React.useState('');
    const [controllerId, setControllerId]     = React.useState(null);
    const [value, setValue]                   = React.useState('1');
    const [accessCodeData, setAccessCodeData] = React.useState({
        name : '',
        companyName : '',
        firstName:'',
    }); 

    const roleList       = useSelector((state) => state.roleData.roleListData);
    const loginUsername  = useSelector((state) => state.accessCodeData.loginUserName);
    const controllerList = useSelector((state) => state.controllerPermissionData.controllersListData);

    useEffect(() => {
        startLoadingRoleList();
        if(controllerList.length <= 0){
            dispatch(loadControllersList());
        }
    }, [startLoadingRoleList]);

    useEffect(() => {
        const maxDate = todayDate.add(29,"day"); // it will include todays date also otherwise if consider 30 it will show 31 days instead of 30 days on calendar
        setFromMaxDate(maxDate);    
    },[]);


    useEffect(() => {
        if(accessCodeDialogBoxStatus === true && selectedUser === null) {
            dispatch(closeAccessCodeDialog());
        }
        dispatch(loadAccessCodeLoginUsernameClear());
    },[accessCodeDialogBoxStatus, dispatch, selectedUser])

    const handleFromDate = (fromDateParam) => {
        if(!fromDateParam) return;
    
        const fromUtc = fromDateParam.startOf("day");
        setFromDate(fromUtc);
        setToMinDate(fromUtc);

        const plus7 = fromUtc.add(6,"day");
        
        if(!toDate || toDate.diff(fromUtc,"day") > 6 ) {
            setToDate(plus7);
        }

        if(toDate && fromUtc.isAfter(toDate)){
            setToDate(fromUtc);
        }

        if(fromMaxDate && plus7.isAfter(fromMaxDate)){
            setToMaxDate(fromMaxDate);
        } else {
            setToMaxDate(plus7);
        }

    }

    const handleToDate = (toDateParam) => {
        if(!toDateParam) return;
        const toUtc = toDateParam.startOf("day");
        setToDate(toUtc);
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    // const handleChangeLevelChange = (e) => {
    //     setUserLevel(e.target.value);
    // }

    const handleFormData = async () => {
        if(!selectedUser || !selectedUser?.login || !fromDate || !toDate || !selectedUser?.roleId || !controllerId){
            swal("Oops!", "Please fill all required fields!", "error");
            return;
        }
       // const selectedFromDate  = dayjs(fromDate);
      //  const unixFromSeconds   = selectedFromDate.unix();
      //  const selectedToDate    = dayjs(toDate);
       // const unixToSeconds     = selectedToDate.unix();
        const formatFromDate    = dayjs(fromDate).format("YYYY-MM-DD");
        const formatToDate      = dayjs(toDate).format("YYYY-MM-DD");
        // let formData = {...selectedUser,'fromDate':formatFromDate,'toDate':formatToDate,'fromDateTimeStamp':unixFromSeconds,'toDateTimeStamp':unixToSeconds}
        let formData = {...selectedUser,'fromDate':formatFromDate,'toDate':formatToDate,'controllerId':controllerId}
        dispatch(addNewAccessCode(formData));
        setSelectedUser(null);
        setFromDate(null);
        setToDate(null);
        setControllerId(null);
       // setUserLevel('');
    }


    const handleNewLoginUserName = () => {
        if(accessCodeData.length === 0 || accessCodeData.name === '' || accessCodeData.companyName === '' || accessCodeData.firstName === ''){
            swal("Oops!", "Please fill all required fields!", "error");
            return false;
        }
        addNewLoginUserName(accessCodeData,selectedUser?.b2c_id);
        setAccessCodeData({
            name : '',
            companyName : '',
            firstName:'',
        });
        dispatch(closeAccessCodeDialog());
        dispatch(loadAccessCodeLoginUsernameClear());
    }

    useEffect(() => {
        if(!selectedUser?.login && selectedUser != null){
            setSelectedUser({...selectedUser,'login':loginUsername})
        }
    },[loginUsername])

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/passwords">Passwords List</Link>
                                <Tab label="Request Passwords" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <AccessCodeForm 
                                fromDate={fromDate}
                                toDate={toDate}
                                fromMaxDate={fromMaxDate}
                                minDate={todayDate.subtract(1, 'day')}
                                toMinDate={toMinDate}
                                handleFromDate={handleFromDate}
                                handleToDate={handleToDate}
                                handleFormData={handleFormData} 
                                selectedUser={selectedUser}
                                setSelectedUser={setSelectedUser}
                                toMaxDate={toMaxDate}
                                //userLevel={userLevel}
                                roleList={roleList}
                                controllersList={controllerList}
                                controllerId={controllerId}
                                setControllerId={setControllerId}
                                //handleChangeLevelChange={handleChangeLevelChange}
                            />
                        </TabPanel>
                    </Grid>
                </TabContext>
                <AccessCodeModal
                    open={accessCodeDialogBoxStatus || false}
                    value={accessCodeData}
                    setAccessCodeData={setAccessCodeData}
                    handleNewLoginUserName={handleNewLoginUserName}
                />
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => ({
  isLoading: getAccessCodeLoading(state),
  accessCodeDialogBoxStatus: getAccessCodeDialogStatus(state),  
  //controllersList: getControllersList(state)
});

const mapDispatchToProps = (dispatch) => ({
    addNewLoginUserName: (data,b2c_id)  => dispatch(createUserName(data,b2c_id)),
    startLoadingRoleList:()             => dispatch(loadRoleList(0,20)),
});

export default connect(mapStateToProps,mapDispatchToProps)(CreateAccessCode);
